import { useTranslation } from 'react-i18next';

import Card from '~components/containers/card';
import EmptyState from '~components/data/emptyState';
import { GeoCoordinate } from '~interfaces';
import { Dimens } from '~themes';

import StaticGoogleMap from './staticGoogleMap';

interface MapCardComponents {
	title?: string;
	geoCoordinate: GeoCoordinate | undefined;
}

const MapCard = ({ title, geoCoordinate }: MapCardComponents) => {
	const { t } = useTranslation();

	return (
		<Card title={title ?? t('location', { ns: 'system' })}>
			{geoCoordinate ?
				<StaticGoogleMap geoCoordinate={geoCoordinate} />
			:	<EmptyState
					sx={{ mt: Dimens.spacingMd }}
					icon={'icon/location'}
					title={t('noLocationFound', { ns: 'system' })}
					description={t('noLocationFoundDescription', { ns: 'system' })}
				/>
			}
		</Card>
	);
};

export default MapCard;
